import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import PortalVue from 'portal-vue'
import VueSocialSharing from 'vue-social-sharing'
import VueAnalytics from 'vue-analytics'

import './plugins/bootstrap-vue'
import './plugins/icons-vue'
import routes from './router'
import guard from './router/guard'
import messages from './i18n'
import store from './store'

Vue.use(PortalVue)
Vue.use(VueRouter)
Vue.use(VueI18n)
Vue.use(VueSocialSharing)
Vue.config.productionTip = false

const render = h => h('div', { attrs: { id: 'app' } }, [
  h('RouterView')
])

const i18n = new VueI18n({ locale: 'es', messages })

const router = new VueRouter({
  routes
})

Vue.use(VueAnalytics, {
  id: 'UA-53212029-1',
  router,
  autoTracking: {
    pageviewTemplate (route) {
      return {
        page: '/especiales/visiones-del-coronavirus/#' + route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})

guard({ router, i18n, store })

// During pre-rendering the initial state is
// injected into the global scope, here we
// fill the store with the initial state.
if (window.__INITIAL_STATE__) store.replaceState(window.__INITIAL_STATE__);

router.beforeResolve(async (to, from, next) => {
  try {
    const components = router.getMatchedComponents(to);

    // By using `await` we make sure to wait
    // for the API request made by the `fetch()`
    // method to resolve before rendering the view.
    await Promise.all(components.map(x => x.fetch && x.fetch({ store })));

    // The `injectInitialState()` function injects
    // the current state as a global variable
    // `__INITIAL_STATE__` if the page is currently
    // pre-rendered.
    if (window.__PRERENDER_INJECTED) injectInitialState(store.state);
  } catch (error) {
    // This is the place for error handling in
    // case the API request fails for example.
    console.log(error);
  }

  return next();
});

new Vue({
  router,
  i18n,
  store,
  render,
}).$mount('#app')
